// test623
(623 && 0);
